import { socialExport } from '@mi-front/api-clients';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { FeatureActions } from './FeatureActions';
import { FeatureState } from './FeatureState';
import { StationCard } from './StationCard';
import { Station } from '@app/core/types/stations';

interface Props {
  platform: SocialPlatform;
  station: Station;
  state?: socialExport.GetConnectionStateDto;
}

export function StationFeature({ platform, station, state }: Props) {
  return (
    <StationCard
      station={station}
      actions={<FeatureActions platform={platform} stationId={station.id} state={state} />}
    >
      <FeatureState stationId={station.id} platform={platform} state={state} />
    </StationCard>
  );
}
